import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

var COMP = environment.component.capacity;

@Component({
  selector: 'app-capacity-data',
  templateUrl: './capacity-data.component.html',
  styleUrls: ['./capacity-data.component.css']
})
export class CapacityDataComponent implements OnInit, OnDestroy {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qctypes : Array<any>=[];
  qtypes : Array<any>=[];
  rows: Array<Object>=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;
  qctypes_new : Array<any>=[];
  qtypes_new : Array<any>=[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".capacity-click").addClass("header_active")

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {

          var qtindex = 0;
          var qtindexobj = {};
          var qtindexrevarr = [];
          var qct : any = data['question_category_type'];
          this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});

          //create an array of question category types using order as array index
          for (var i=0; i < qct.length; i++){
            var span = qct[i].question_type.length;
            if(span > 1) span += 1;
            this.qctypes[qct[i].order-1] = {"name":qct[i].name,"span":span,"question_type":qct[i].question_type,
              "category_group":'', "order":qct[i].order, "display_text": qct[i].display_text,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
          }
          this.qctypes.splice(-1,1);            //slice the last element of question category(i.e c5 Pool Category)

         //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
          for (var i=0; i < this.qctypes.length; i++){

            var qctypeobj = this.qctypes[i];
            var qtarr = this.qctypes[i].question_type;

            //create an array of qtypes in one qctype
            var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
            for (var j=0; j < qtarr.length; j++)
              arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order, display_text: qtarr[j].display_text};

            //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
            //and reverse lookup columnorder => qtype
            for (var k=0; k < arr.length; k++){
            if(arr[k].name!='Details' && arr[k].name!='None'){
              this.qtypes.push(arr[k]);
              qtindexobj[arr[k].id] = qtindex;
              qtindexrevarr[qtindex] = arr[k].name;
              qtindex++;
            }}

            //move qtindex forward to add columns for avearage and response if needed
            if(qctypeobj.average){
              this.qtypes.push({id:0,"name":"Average",order:this.qtypes[this.qtypes.length-1].order, display_text: "Average Score"});
              qtindexrevarr[qtindex] = "Average";
              qtindex++;
            }
            if(qctypeobj.positive_response_percent){
              this.qtypes.push({id:0,"name":"+ve Response %",order:this.qtypes[this.qtypes.length-1].order, display_text: "Proportion of Positive Response for "+qctypeobj.display_text});
              qtindexrevarr[qtindex] = "Response";
              qtindex++;
            }
          }
         this.qtindexobj = qtindexobj;
         this.qtindexrevarr = qtindexrevarr;

          var ctar_wo_order = data['category'];
          var ctar = [null,null,null,null,null,null];
          for (var k=0; k < ctar_wo_order.length; k++){
            ctar[ctar_wo_order[k].order-1] = ctar_wo_order[k];
          }
         console.log('ctar_wo_order');
         console.log(ctar_wo_order)
         console.log('ctar');
         console.log(ctar);
          var rows = {};
          var row = {};
          var roworder = 0;
          function get_subcat_index(co, sco){
          /*co category order, sco subcategory order, sci subcat_index*/
            let sci;
            if (co==1 && sco==1) sci = 0;
            if (co==2 && sco==1) sci = 1;
            if (co==3 && sco==1) sci = 2;
            if (co==3 && sco==2) sci = 3;
            if (co==4 && sco==1) sci = 4;
            if (co==4 && sco==2) sci = 5;
            if (co==5 && sco==1) sci = 6;
            if (co==5 && sco==2) sci = 7;
            if (co==6 && sco==1) sci = 8;
            return sci;
          }

          function label_name(ct){
            return ct.name.replace("Target ","").replace("Indicator ","");
          }

          for (var c = 0; c < ctar.length; c++){
            var ct = ctar[c];
            row["catname"] = label_name(ct);
            var scl = ct.sub_category.length;
            row["rowspan"] = scl;
            var catrow1 = true;
            for (var sc = 0; sc < scl; sc++){
              var sct = ct.sub_category[sc];
              roworder = get_subcat_index(ct.order,sct.order);
              var newrow = {catname:row["catname"], rowspan:row["rowspan"], roworder:roworder};
              newrow["subcatname"] = label_name(sct);
              newrow["catrow"] = catrow1;
              if(sct.order == 2)
                newrow["rowspan"] = 0;
              catrow1 = false;
              var resultsarr = Array.apply(null, Array(qtindex)).map(function () {});
              newrow["resultsarr"] = resultsarr;
              rows[sct.id] = newrow;
            }
          }
          this.rowsobj = rows;
         this.subscription2 = this.results$.subscribe( data => {

               var rows_temp = [];
               for(var i=0;i<data.length;i++){
                 var res = data[i];
                 var colidx = this.qtindexobj[res.question_type];
                 this.rowsobj[res.sub_category].resultsarr[colidx] = res;
               }
                //go through each row
               var data_valid;
               for(var ri in this.rowsobj){
                 data_valid = true;
                 var rowresults = this.rowsobj[ri].resultsarr;
                 var qcat_count = 0, weight_sum = 0, all_3 = true, none_1 = false, count_1 = 0, count_non_empty = 0;
                 var curr_qcat_name = '';
                 //go through each result in the row
                 for(var rri = 0; rri < rowresults.length; rri++){
                   var resobj = rowresults[rri];
                   if(resobj)
                     curr_qcat_name = resobj.question_category_type_name;
                   if(curr_qcat_name == 'c1'){
                     if(resobj && ['Other','Details'].indexOf(resobj.question_type_name) < 0){//if qtype is none of these
                       qcat_count++;
                       weight_sum += resobj.value_weight;
                     }
                     else if (this.qtindexrevarr[rri] == 'Average'){
                       var avg_weight = weight_sum/qcat_count;
                       var avg_value;
                       if (avg_weight<=1)
                         avg_value = "Not Critical";
                       else if (avg_weight<=2)
                         avg_value = "Somewhat Critical";
                       else if (avg_weight<=3)
                         avg_value = "Significantly Critical";
                       else if (avg_weight<=4)
                         avg_value = "Very Critical";
                       rowresults[rri] = {value:avg_value};
                     }
                   }
                   else if(curr_qcat_name == 'c2')
                     continue;
                   else if(curr_qcat_name == 'c3'){
                     if(resobj){
                       if(resobj.question_type_name != "Details"){
                         count_non_empty++;
                         if(resobj.value_weight == 1)
                          count_1++;
                       }
                       if( ['None', 'Other','Details'].indexOf(resobj.question_type_name) < 0)
                         all_3 = (resobj.value_weight == 3 && all_3);
                       else if (resobj.question_type_name == "None")
                         none_1 = (resobj.value_weight == 1);
                     }
                     else if (this.qtindexrevarr[rri] == 'Response'){
                       var v,response_value;
                        if(all_3)
                          v = 9999;
                        else if (none_1)
                          v = 0;
                        else
                          v = count_1/count_non_empty;
                        if (v == 9999)
                          response_value = 0;
                        else
                          response_value = v;
                       rowresults[rri] = {value:response_value.toFixed(2)*100 + "%"};
                       console.log(rowresults[rri]);
                       all_3 = true, none_1 = false, count_1 = 0, count_non_empty = 0;
                     }
                   }
                   else if(curr_qcat_name == 'c4'){
                     if(resobj){
                       if(resobj.question_type_name != "Details"){
                         count_non_empty++;
                         if(resobj.value_weight == 1)
                           count_1++;
                       }
                       if( ['Other','Details'].indexOf(resobj.question_type_name) < 0)
                         all_3 = (resobj.value_weight == 3 && all_3);
                     }
                     else if (this.qtindexrevarr[rri] == 'Average'){
                       var response_value;
                       if(all_3)
                         response_value = 0;
                       else
                         response_value = (count_1/count_non_empty)*100;
                         response_value = response_value.toFixed(0) + "%";
                       rowresults[rri] = {value:response_value};
                       all_3 = true, none_1 = false, count_1 = 0, count_non_empty = 0;
                     }
                   }
                 }
                 for(var rri = 0; rri < rowresults.length; rri++){
                   if(!rowresults[rri])
                     data_valid = false;
                 }
                 if(data_valid)
                  rows_temp.push(this.rowsobj[ri]);
               }

               var rows_ordered = Array.apply(null, Array(rows_temp.length)).map(function () {});
               for (var r=0; r<rows_temp.length; r++)
               rows_ordered[rows_temp[r].roworder] = rows_temp[r];
               this.rows = rows_ordered;
               console.log('this.rows');
               console.log(this.rows);

this.qctypes_new = [
{
'display_text':'1. In which categories is it most critical to build capacity in the relevant national Government agencies, Departments or Ministries in order to reach the agreed 2030 aspiration for indicator?',
'rspan':1,'cspan':9,
'min_col_width':10
},{
'display_text':'2. What level of national Government capacity is available right now to achieve the agreed 2030 aspiration for this indicator?',
'rspan':2,'cspan':1,
'min_col_width':10
},{
'display_text':'3. Which mechanisms have been adopted to build capacity at national level and/or adjust it to new challenges under this indicator?',
'rspan':1,'cspan':11,
'min_col_width':10
},{
'display_text':'4. Is there evidence that the national Government is on track to build critical capacity due to the existence of impartial and fair policy for capacity development and the enforcement of mechanisms that deliver in different categories',
'rspan':1,'cspan':10,
'min_col_width':10
}];

this.qtypes_new = [
{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'f',
'min_col_width':10
},{
'display_text':'g',
'min_col_width':10
},{
'display_text':'Other',
'min_col_width':10
},{
'display_text':'Average Need Score',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'f',
'min_col_width':10
},{
'display_text':'g',
'min_col_width':10
},{
'display_text':'h',
'min_col_width':10
},{
'display_text':'i',
'min_col_width':10
},{
'display_text':'Other',
'min_col_width':10
},{
'display_text':'Proportion of positive responses',
'min_col_width':10
},{
'display_text':'a',
'min_col_width':10
},{
'display_text':'b',
'min_col_width':10
},{
'display_text':'c',
'min_col_width':10
},{
'display_text':'d',
'min_col_width':10
},{
'display_text':'e',
'min_col_width':10
},{
'display_text':'f',
'min_col_width':10
},{
'display_text':'g',
'min_col_width':10
},{
'display_text':'h',
'min_col_width':10
},{
'display_text':'Other',
'min_col_width':10
},{
'display_text':'Average Progress Score',
'min_col_width':10
}];

for(var i=0;i<this.qctypes_new.length;i++)
this.qctypes_new[i].min_col_width = parseInt((this.qctypes_new[i].display_text.length*1.5).toFixed(0));

for(var i=0;i<this.qtypes_new.length;i++)
this.qtypes_new[i].min_col_width = parseInt((this.qtypes_new[i].display_text.length*1.5).toFixed(0));


            },
             error => {
               this.alertService.error(error);
             });
       },
       error => {
           this.alertService.error(error);
       });
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

ngOnDestroy() {
  //  used in template
  this.qctypes = null;
  this.qtypes = null;
  this.rows = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

  capacityBtnClick(){
      this.router.navigateByUrl('/sdg/capacity-resource')
  }
  quesBtnClick(){
      this.router.navigateByUrl('/sdg/capacity-quest')
  }
  dataBtnClick(){
      this.router.navigateByUrl('/sdg/capacity-data')
  }
  reportBtnClick(){
      this.router.navigateByUrl('/sdg/capacity-report')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/capacity-data/capacity-data.component.ts